module.exports = __webpack_public_path__ + "8ecd4aa3aa4bff56829f536b882d5956.jpg";